import React, { useState } from 'react';
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

// Form
import { useFormik } from 'formik';
import * as yup from 'yup';

// MUI Components
import Typography from '@mui/material/Typography';
import { Box, InputLabel, TextField, CircularProgress } from '@mui/material';

// Reuse CreateTag modal styles for identical UI
import '~/components/Settings/Tags/CreateTag/styles.scss';

const CreateSubCompany = (props) => {
  const formId = 'create-sub-company-form';
  const { openModal, handleCloseModal } = props;

  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required('Company name is required')
      .max(100, 'Company name must be at most 100 characters'),
    address: yup
      .string()
      .trim()
      .required('Company address is required')
      .max(200, 'Company address must be at most 200 characters'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      address: '',
    },
    validationSchema: validationSchema,
    onSubmit: async () => {
      try {
        setLoading(true);
        // Placeholder submit. Integrate API call here when available.
        setTimeout(() => {
          setLoading(false);
          handleClose();
        }, 500);
      } catch (e) {
        setLoading(false);
      }
    },
  });

  const handleClose = () => {
    handleCloseModal();
    formik.resetForm();
  };

  return (
    <OlcFormModal
      open={openModal}
      onClose={handleClose}
      title="Add New Sub-Company"
      className="createTagModalWrapper"
      footer={
        <>
          <OlcButton
            variant="secondary"
            type="button"
            onClick={handleClose}
            className="btnSecondary btnCancel"
            disabled={loading}
          >
            Cancel
          </OlcButton>
          <OlcButton
            variant="primary"
            className="btnPrimary btnSave"
            type="submit"
            form={formId}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'white',
                  width: '20px !important',
                  height: '20px !important',
                }}
              />
            ) : (
              'Save'
            )}
          </OlcButton>
        </>
      }
    >
      <form
        id={formId}
        className="updateFormWrapper"
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        noValidate
      >
        <Box sx={{ maxWidth: '100%', marginInline: 'auto', textAlign: 'start' }}>
          <InputLabel htmlFor="company-name" className="inputLabel formLabel">
            Company Name
          </InputLabel>
          <TextField
            id="company-name"
            placeholder="Enter Company Name"
            fullWidth
            name="name"
            autoComplete="off"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            className={
              formik.touched.name && formik.errors.name
                ? 'invalid formInput inputField formField'
                : 'inputField formField'
            }
            sx={{
              '& input::placeholder': {
                color: '#000',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: 'normal',
                fontFamily: 'Inter',
                fontStyle: 'normal',
              },
              outline: 'none',
              '&:focus': {
                outline: 'none',
              },
              mb: 2,
            }}
          />
          {formik.touched.name && formik.errors.name ? (
            <Typography className="errorMessage">
              <sup>*</sup>
              {formik.errors.name}
            </Typography>
          ) : null}

          <InputLabel htmlFor="company-address" className="inputLabel formLabel" sx={{ mt: 0 }}>
            Company Address
          </InputLabel>
          <TextField
            id="company-address"
            placeholder="Enter Company Address"
            fullWidth
            name="address"
            autoComplete="off"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.address}
            className={
              formik.touched.address && formik.errors.address
                ? 'invalid formInput inputField formField'
                : 'inputField formField'
            }
            sx={{
              '& input::placeholder': {
                color: '#000',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: 'normal',
                fontFamily: 'Inter',
                fontStyle: 'normal',
              },
              outline: 'none',
              '&:focus': {
                outline: 'none',
              },
            }}
          />
          {formik.touched.address && formik.errors.address ? (
            <Typography className="errorMessage">
              <sup>*</sup>
              {formik.errors.address}
            </Typography>
          ) : null}
        </Box>
      </form>
    </OlcFormModal>
  );
};

export default CreateSubCompany;
